module.exports = __webpack_public_path__ + "img/banner-05备份.6e23aca7.png";